
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lcv-booking/[routeSlug]",
      function () {
        return require("private-next-pages/lcv-booking/[routeSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lcv-booking/[routeSlug]"])
      });
    }
  